<template>
  <div>
    <v-row class="pb-0 mb-0" v-if="showContentTypeWarning">
        <v-col cols="12" align-self="center">
            <v-alert
                dense
                outlined
                class="pt-1 pb-1"
                type="info"
                color="grey darken-1"
            >
            {{ $t("AdvancedSearchWarning") }}
            </v-alert>
        </v-col>
    </v-row>
    <div v-for="(item, index) in filterItems" :key="item.uuid">
        <v-row>
            <v-col cols="1" align-self="center" class="px-1 pb-0">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    large
                    color="error"
                    icon
                    @click="removeFilter(item.uuid)"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                </template>
                <span>{{ $t("Remove") }}</span>
            </v-tooltip>
            </v-col>
            <v-col cols="5" class="pb-0">
            <v-autocomplete
                v-model="item.fieldTitle"
                @change="item.fieldValues = []"
                v-bind:label="$t('Field')"
                :items="getFieldTitles()"
                :error-messages="fieldTitleErrors(index)"
            ></v-autocomplete>
            </v-col>
            <v-col cols="5" class="pb-0">
            <v-autocomplete
                v-model="item.fieldValues"
                :items="getFieldValues(item.fieldTitle)"
                v-bind:label="$t('Value')"
                :error-messages="fieldValuesErrors(index)"
                multiple
            ></v-autocomplete>
            </v-col>
            <v-col cols="1" align-self="center" class="mx-0 px-0 pb-0">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    large
                    color="primary"
                    icon
                    @click="addFilter()"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                </template>
                <span>{{ $t("Add") }}</span>
            </v-tooltip>
            </v-col>
        </v-row>
      <v-subheader v-if="!isLastFilter(item.uuid)">---OR---</v-subheader>
    </div>
  </div>
</template>
<script>
import FilterItem from '@/ecm/models/search/FilterItem';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
export default {
    name: 'FilterModal',
    props: {
        fieldList: {
            type: Array,
            default: () => [],
        },
        showContentTypeWarning: {
            type: Boolean,
            default: false,
        },
        clear: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        clear(newVal) {
            if (!newVal) return;
            this.filterItems = [];
            this.addFilter();
        }
    },
    created() {
        this.addFilter();
    },
    data() {
        return {
            modal: {
                title: this.$t('ToFilter'),
                key: 'filterModal',
            },
            open: false,
            filterItems: [],
        };
    },
    mixins: [validationMixin],
    validations: {
        filterItems: {
            $each: {
                fieldTitle: { required },
                fieldValues: { required },
            },
        },
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
    },
    methods: {
        getFieldTitles() {
            if (this.fieldList || this.fieldList.length > 0) {
                return Array.from(
                    new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
                );
            } else {
                return [];
            }
        },
        getFieldValues(fieldTitle) {
            if (this.fieldList || this.fieldList.length > 0) {
                return Array.from(
                    new Set(
                        this.fieldList
                            .filter((f) => f.Title == fieldTitle && f.IsVisible)
                            .map((f) => f.Value)
                    )
                );
            } else {
                return [];
            }
        },
        fieldTitleErrors(index) {
            const errors = [];
            if (!this.$v.filterItems.$each[index].fieldTitle.$dirty) return errors;
            !this.$v.filterItems.$each[index].fieldTitle.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        fieldValuesErrors(index) {
            const errors = [];
            if (!this.$v.filterItems.$each[index].fieldValues.$dirty) return errors;
            !this.$v.filterItems.$each[index].fieldValues.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
        addFilter() {
            this.filterItems.push(new FilterItem());
        },
        addFieldToFilter(fieldToFilter) {
            if (this.filterItems.find(x => x.fieldTitle === fieldToFilter)) return;

            this.filterItems = this.filterItems.filter(x => x.fieldValues.length !== 0);
            this.addFilter();

            const lastFilterIndex = this.filterItems.length - 1;
            const lastItem = this.filterItems[lastFilterIndex];

            if (lastItem.fieldTitle === '') {
                this.filterItems[lastFilterIndex].fieldTitle = fieldToFilter;
                return;
            }
            this.filterItems[lastFilterIndex].fieldTitle = fieldToFilter;
        },
        removeFilter(uuid) {
            this.filterItems = this.filterItems.filter((item) => item.uuid !== uuid);
            if (this.filterItems.length == 0) {
                this.addFilter();
            }
        },
        onFiltered() {
            if (this.filterItems.length == 1 && this.filterItems[0].fieldTitle == '') {
                this.$emit('on-filtered', []);
                return true;
            } else {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }
                this.$emit('on-filtered', JSON.parse(JSON.stringify(this.filterItems)));
                return true;
            }
        },
        reset() {
            this.filterItems = this.filterItems.filter(x => x.fieldValues.length !== 0 && x.fieldTitle !== '');
            if (this.filterItems.length === 0) {
                this.addFilter();
            }
            this.$v.$reset();
        },
        isLastFilter(uuid) {
            if (this.filterItems.length <= 1) return true;
            return this.filterItems[this.filterItems.length - 1].uuid == uuid;
        },
    },
};
</script>
